import canvas2svg from 'canvas2svg';

// Function to create a segmented circle icon as a data URL
export function createSegmentedCircleIcon(entityColors: string[], count: number = 0, size: number = 24): string {
    let scaleFactor = 1;
    if (count > 0) {
        scaleFactor = scaleFactor + 0.4 * Math.log10(count);
    }

    const padding = 10;
    const ctx: CanvasRenderingContext2D = canvas2svg({ width: size * scaleFactor + padding, height: size * scaleFactor + padding });

    const center = (size * scaleFactor + padding) / 2;
    const radius = (size * scaleFactor / 2) - 4; // leave room for stroke width
    const segments = entityColors.length;

    // Fill the circle with a base color (optional)
    ctx.beginPath();
    ctx.arc(center, center, radius, 0, 2 * Math.PI);
    ctx.fillStyle = 'white'; // or any other fill color
    ctx.fill();

    // Draw each border segment
    ctx.lineWidth = 2;
    for (let i = 0; i < segments; i++) {
        const startAngle = (i / segments) * 2 * Math.PI;
        const endAngle = ((i + 1) / segments) * 2 * Math.PI;
        ctx.beginPath();
        ctx.arc(center, center, radius, startAngle, endAngle);
        ctx.strokeStyle = entityColors[i] || '#000000';
        ctx.stroke();
    }

    const fontSize = Math.floor(radius * 1.25);

    if (count) {
        ctx.font = `bold ${fontSize}px sans-serif`;
        ctx.fillStyle = 'black';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(count.toString(), center, center);
    }

    // return `data:image/svg+xml;utf8,${encodeURIComponent((ctx as any).getSerializedSvg())}`;
    // Get the generated SVG string
    let svgString = (ctx as any).getSerializedSvg();

    const filterDefinition = `
      <defs>
        <filter id="shadow" filterUnits="userSpaceOnUse" x="-2" y="-2" width="${size * scaleFactor + padding}" height="${size * scaleFactor + padding}">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2" result="blur"/>
          <feOffset in="blur" dx="2" dy="2" result="offsetBlur"/>
          <feComponentTransfer in="offsetBlur" result="lightShadow">
            <feFuncA type="linear" slope="0.5" intercept="0"/>
          </feComponentTransfer>
          <feMerge>
            <feMergeNode in="lightShadow"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>`;

    // Replace the empty <defs/> with our filter definition
    svgString = svgString.replace('<defs/>', filterDefinition);

    // Apply the filter to the entire group (or target only the base circle if preferred)
    svgString = svgString.replace('<g>', '<g filter="url(#shadow)">');

    return `data:image/svg+xml;utf8,${encodeURIComponent(svgString)}`;
}
